import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const RealEstate: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      width: '32px',
      height: '32px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path
      d="M5.33594 11.4668V28.0001H26.6693V11.4668"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66406 13.3333L15.9974 4L29.3307 13.3333"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 28.0007V20.0007C20 18.5273 18.8067 17.334 17.3333 17.334H14.6667C13.1933 17.334 12 18.5273 12 20.0007V28.0007"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export const RealEstateDark: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      width: '24px',
      height: '24px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path
      d="M5.33594 11.4668V28.0001H26.6693V11.4668"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66406 13.3333L15.9974 4L29.3307 13.3333"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 28.0007V20.0007C20 18.5273 18.8067 17.334 17.3333 17.334H14.6667C13.1933 17.334 12 18.5273 12 20.0007V28.0007"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
